// TotalInventoryShortage Mutations

export const updateTotalInventoryShortageList = (state, payload) => {
  state.totalInventoryShortageList = payload
}

export const fetchTotalInventoryShortageCount = (state, payload) => {
  state.totalInventoryShortageCount = payload
}
